import React, { FC } from "react";
import Image from "next/image";
import { Maybe } from "graphql/jsutils/Maybe";
import { Heading } from "@pepdirect/ui/heading";
import { getCloudflareLoader } from "@pepdirect/helpers/cloudflareImages";
import { endpoints } from "config";
import st from "./product.module.scss";

interface FulfillmentItemProps {
  item: {
    quantity?: number | null;
    item?: Maybe<{
      title?: string | null;
      imgUrl?: string | null;
    }>;
  } | null;
}

export const FulfillmentItemProduct: FC<FulfillmentItemProps> = ({
  item: fulfillmentItem = {},
}) => {
  if (!fulfillmentItem) return null;
  const { item, quantity } = fulfillmentItem;

  if (!item) return null;
  const { title, imgUrl } = item;
  return (
    <div className={st.wrapper}>
      <figure className={st.imageWrapper}>
        <Image
          src={imgUrl || "/"}
          layout="fill"
          objectFit="contain"
          loader={getCloudflareLoader(endpoints.cdn)}
          alt="fulfillment item"
        />
      </figure>

      <div className={st.details}>
        <Heading level="h3" size="xs">
          {title}
        </Heading>
        <span className={st.quantity}>Quantity: {quantity}</span>
      </div>
    </div>
  );
};
